import { ReactNode } from 'react';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import { cn } from '@/utils/cn';

interface DashboardGridProps {
    children: ReactNode;
    className?: string;
}

export const DashboardGrid = ({ children, className }: DashboardGridProps) => {
    return (
        <div className={cn('grid w-full grid-cols-12 gap-6', className)}>
            <ErrorBoundary>{children}</ErrorBoundary>
        </div>
    );
};
